(function () {
  'use strict';

  const root = document.getElementById('ck-start-app');
  if (!root) return;

  const proxyUrl = root.dataset.proxyUrl || '/apps/cricket-kit';
  const form = root.querySelector('#ck-start-form');
  const successTpl = document.getElementById('ck-start-success');
  const statusEl = form.querySelector('[data-status]');
  const submitBtn = form.querySelector('.ck-intake__submit');
  const submitLabel = form.querySelector('[data-submit-label]');
  const spinner = form.querySelector('[data-submit-spinner]');

  function showStatus(msg, kind) {
    statusEl.hidden = false;
    statusEl.className = 'ck-intake__status ck-intake__status--' + (kind || 'info');
    statusEl.textContent = msg;
    statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setLoading(loading) {
    submitBtn.disabled = loading;
    spinner.hidden = !loading;
    submitLabel.textContent = loading ? 'Creating…' : 'Get my order link';
  }

  function renderSuccess(data) {
    const node = successTpl.content.firstElementChild.cloneNode(true);
    const orderUrl = `${window.location.origin}${data.order_path}`;
    node.querySelector('[data-magic-link]').value = orderUrl;
    node.querySelector('[data-order-link]').href = data.order_path;
    node.querySelector('[data-action="copy"]').addEventListener('click', () => {
      navigator.clipboard.writeText(orderUrl).then(() => alert('Link copied!'));
    });
    root.replaceChildren(node);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!form.team_name.value.trim() || !form.contact_name.value.trim() || !form.email.value.trim()) {
      showStatus('Team name, contact name, and email are required.', 'error');
      return;
    }

    setLoading(true);
    statusEl.hidden = true;
    try {
      const res = await fetch(`${proxyUrl}/start`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          team_name: form.team_name.value.trim(),
          contact_name: form.contact_name.value.trim(),
          email: form.email.value.trim(),
          phone: form.phone.value.trim(),
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        const msg = data.error === 'missing_team_name' ? 'Team name is required.' :
                    data.error === 'missing_email' ? 'Email is required.' :
                    (data.error || 'Sorry — something went wrong. Please try again.');
        showStatus(msg, 'error');
        setLoading(false);
        return;
      }
      renderSuccess(data);
    } catch (err) {
      showStatus('Network error: ' + err.message, 'error');
      setLoading(false);
    }
  });
})();
